export const track = (eventName, payload) => {
  if (eventName && payload) {
    window.LIFE_CYCLE_EVENT_BUS.trigger(`buybox.${eventName}`, payload);
  }
};
